import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-nao-encontrada',
  templateUrl: './nao-encontrada.component.html',
  styleUrls: ['../../juridico.component.css']
})
export class NaoEncontradaComponent implements OnInit {

  constructor(private meta: Meta) {
    // this.meta.updateTag(
    //   { name: 'title', content: 'Reachr - Página não encontrada!'
    // });
    // this.meta.updateTag(
    //   { name: 'description', content: 'Gerencie todo o seu processo de recrutamento e seleção em uma única plataforma. Reachr, a solução prática e inteligente de recrutamento digital.'
    // });
    // this.meta.updateTag(
    //   { name: 'keywords', content: 'vagas de emprego, oportunidade de trabalho, agencia de emprego, vagas, emprego, vaga de emprego, trabalhe conosco comunidade de emprego,'
    // });
  }

  ngOnInit(): void {
  }

}
